var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-holder"},[_c('div',{staticClass:"lds-ripple",style:(`width:${this.size}px;height:${this.size}px;`)},[_c('div'),_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }